<template lang="pug">
menu-context-menu(style="height: 100%; width: 100%;", :position="saveMouseEvent")
  slot
  template(slot="contextmenu")
    ModuleOutlet(type="contextMenu")
</template>


<script lang="ts">
import { ContextMenuComponent } from "./script"
export default ContextMenuComponent
</script>